module.exports = __webpack_public_path__ + "img/aiznyy.873e861e.png";